<mat-form-field class="tags-chip-list w-full">
  <mat-chip-grid #chipList aria-label="Tags selection">
    <div class="email-search-tag-input__chips">
      @for (tag of selectedTags; track tag.tag) {
        <app-tag-component
          [tag]="tag"
          (deleteTag)="removeTag($event)"
          [withDelete]="true" />
      }

      <input
        placeholder="{{ 'tags' | translate }}"
        #tagInput
        [formControl]="tagCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        (focus)="onInputFocus()" />
    </div>
  </mat-chip-grid>
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selectedTag($event)">
    @for (tag of filteredTags | async; track tag) {
      <mat-option [value]="tag">
        <mat-icon
          class="small"
          [ngStyle]="{ color: tag?.color ?? TAGS_COLORS.grey }">
          label
        </mat-icon>
        {{ tag.tag }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
